import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Table } from 'react-bootstrap'
import { isEmpty } from 'lodash'
import { convertCentsToWhole } from '../../../utils/couriers'
import { formatDate } from '../../../utils/date'

export default class BonusTierTable extends Component {
    renderMultiOrDefault = (values, defaultValue) => (isEmpty(values) ? defaultValue : values.join(', '))

    renderDays = ({ daysOfWeek, specialDay, validFrom, validTo }) => {
        if (specialDay) {
            return `${formatDate(validFrom)} to ${formatDate(validTo)}`
        }

        return this.renderMultiOrDefault(daysOfWeek, 'All days')
    }

    renderValidToFrom = (validFrom, validTo) => {
        if (validFrom === null && validTo === null) {
            return 'Always'
        }
        let from = 'Always'
        if (validFrom) {
            from = formatDate(validFrom)
        }
        let to = 'forever'
        if (validTo) {
            to = formatDate(validTo)
        }
        return `${from} to ${to}`
    }

    renderRows = () => {
        const { compensationTiers, onSelect, onEdit } = this.props

        return compensationTiers.map((tier) => (
            <tr key={tier.id} onClick={onEdit(tier)} style={{ cursor: 'pointer' }}>
                <td>
                    <input
                        type="checkbox"
                        name={tier.type}
                        value={tier.id}
                        onClick={onSelect}
                        checked={tier.selected}
                    />
                </td>
                <td>{this.renderMultiOrDefault(tier.cities, 'All cities')}</td>
                <td>{this.renderDays(tier)}</td>
                {tier.incrementalPriceInCents === 0 ? (
                    <td>
                        {convertCentsToWhole(tier.fixedPriceInCents)} {tier.currency}
                    </td>
                ) : (
                    <td>
                        {convertCentsToWhole(tier.incrementalPriceInCents)} {tier.currency}
                    </td>
                )}
                <td> {tier.lowerBound === null ? 0 : tier.lowerBound} </td>
                <td> {tier.upperBound === null ? 'infinity' : tier.upperBound} </td>
                <td>{this.renderValidToFrom(tier.validFrom, tier.validTo)}</td>
            </tr>
        ))
    }

    render() {
        const { onSelectAll, type } = this.props

        return (
            <Table bordered hover>
                <thead>
                    <tr>
                        <th>
                            <input type="checkbox" name={type.id} onChange={onSelectAll} />
                        </th>
                        <th>City</th>
                        <th>Days</th>
                        <th>{type.label}</th>
                        <th>Start range (inclusive)</th>
                        <th>End range (exclusive)</th>
                        <th>Valid Interval</th>
                    </tr>
                </thead>
                <tbody>{this.renderRows()}</tbody>
            </Table>
        )
    }
}

BonusTierTable.propTypes = {
    type: PropTypes.object.isRequired,
    compensationTiers: PropTypes.array.isRequired,
    onSelect: PropTypes.func.isRequired,
    onSelectAll: PropTypes.func.isRequired,
    onEdit: PropTypes.func.isRequired,
}
